module.exports = {
      id: "haarwensen-usage",
      viewBox: "0 0 487.36 104.98",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#haarwensen-usage",
      toString: function () {
        return this.url;
      }
    }